export enum Notification {
    EMPTY_LABEL_NAME_ERROR = 0,
    NON_UNIQUE_LABEL_NAMES_ERROR = 1
}
